import React from 'react';
import { Button } from 'react-bootstrap';
import { SearchEntity } from 'v2/models';
import classnames from 'classnames';
import { ExpiredClockIcon } from 'v2/icons';
import { useRenewSearch } from './useRenewSearch';
import { toast } from 'react-toastify';

type IRenewRequestButton = Pick<SearchEntity, 'expires_at' | 'free' | 'id'>;

export const RenewRequestButton = ({ id }: IRenewRequestButton) => {
  const { mutateAsync: renewRequest } = useRenewSearch(id);

  const handleClick = async () => {
    try {
      await renewRequest();
      toast.success('Request renewed');
    } catch (e) {
      toast.error("Couldn't renew the request");
    }
  };

  const text = 'Renew Request';

  return (
    <Button
      className={classnames('mr-2', 'btn btn-secondary-dark', 'editBtn')}
      variant="secondary"
      onClick={handleClick}
      title={text}
    >
      <ExpiredClockIcon hue="blue" />
      <div className={classnames('ml-2')}>{text}</div>
    </Button>
  );
};
